import { Link } from 'react-router-dom';
import './Breadcrumb.scss';

interface Props {
  path: {
    text: string,
    to?: string,
  }[];
}

export default function Breadcrumb({ path }: Props) {
  return (
    <div className='Breadcrumb'>
      {path.map((step, index) => (
        <div className='Step' key={index}>
          {step.to
            ? (
                <Link
                  className='StepLink'
                  to={step.to}
                >
                  {step.text}
                </Link>
            ) 
            : (
                <div className='StepText'>
                  {step.text}
                </div>
            )
          }
          {(index !== path.length - 1) &&
            <div className='Separator'>
              &gt;
            </div>
          }
        </div>
      ))}
    </div>
  );
}
